import { Url } from '../../utils/codecUtils';
import { ExtensionEvent } from '../models/event';
import { hookSchema } from '../models/hook.schema';
import { createHookFromTemplatePayloadSchema } from './createFromTemplate.schema';

export type CreateHookFromTemplatePayload = {
  name: string;
  hookTemplate: Url;
  events: ExtensionEvent[];
  queues: Url[];
  tokenOwner: Url | null;
};

export const createFromTemplate = (payload: CreateHookFromTemplatePayload) => {
  return {
    endpoint: `/hooks/create`,
    method: 'POST',
    responseSchema: hookSchema,
    payload,
    payloadSchema: createHookFromTemplatePayloadSchema,
  } as const;
};
